import Cart from 'cart-store';
import { formatMoney } from 'utils';

class BigDropCartUpsell extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(this.dataset.threshold);
    this.button = this.querySelector('button');
    this.onAdd = () => this.add();
    this.button?.addEventListener('click', this.onAdd);
    this.unsubscribe = Cart.subscribe(({ cart }) => this.update(cart));
    this.update(Cart.getState().cart);
  }

  disconnectedCallback() {
    this.unsubscribe?.();
    this.button?.removeEventListener('click', this.onAdd);
  }

  update(cart) {
    // Match the existing shipping bar: merchandise total after discounts.
    const remaining = Math.max(0, this.threshold - cart.total_price);
    this.querySelector('[data-remaining]').innerHTML = formatMoney(remaining, window.theme.money_format);
    this.querySelector('[data-below]').hidden = remaining === 0;
    this.querySelector('[data-unlocked]').hidden = remaining > 0;
    this.querySelector('progress').value = Math.min(this.threshold, Math.max(0, cart.total_price));
    const product = this.querySelector('[data-product]');
    if (product) {
      if (remaining === 0 && product.contains(document.activeElement)) {
        this.querySelector('[data-message]').focus({ preventScroll: true });
      }
      product.hidden = remaining === 0;
    }
  }

  async add() {
    if (this.button.disabled) return;
    const error = this.querySelector('[data-error]');
    const label = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = 'Adding…';
    this.button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      await Cart.add({ id: this.button.dataset.variant, quantity: 1 });
    } catch (failure) {
      error.textContent = failure.message || 'Unable to add this product. Please try again.';
      error.hidden = false;
    } finally {
      await Cart.resetVariantsBeingAdded(this.button.dataset.variant);
      this.button.disabled = false;
      this.button.textContent = label;
      this.button.removeAttribute('aria-busy');
    }
  }
}

customElements.define('bigdrop-cart-upsell', BigDropCartUpsell);
